import template from './datatable.html';
import controller from './datatable.controller';
import './datatable.scss';

let datatableComponent = {
  restrict: 'E',
  bindings: {
    filter: '=',
    eventId: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default datatableComponent;



// WEBPACK FOOTER //
// ./client/app/common/datatable/datatable.component.js